import React, { useEffect, useState } from "react";
import { getGiftListByUser } from "../../utils/helper";
import FriendWishComponent from "./FriendWishComponent";

const FriendModal = ({ setShowModal, modal }) => {
  const [giftsList, setGiftsList] = useState([])

  useEffect(() => {
    getGiftListByUser(modal.id)
      .then((data) => {
        setGiftsList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
      })
      .catch((error) => console.log(error))
  }, [modal.id])

  return (
    <div className="max-w-full global-px">
      <header className="flex w-full justify-between items-center py-3">
        <svg
          className="w-6 h-6 cursor-pointer"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => setShowModal(false)}
        >
          <title>Retour</title>
          <path
            fillRule="evenodd"
            d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
            clipRule="evenodd"
          />
        </svg>
        <h2 className="text-center font-bold text-xl w-full">
          Les souhaits de {modal.pseudo}
        </h2>
      </header>
      <p className="text-darkRed">Nombre de souhaits : {giftsList?.length ?? "0"}</p>
      <div className="md:grid md:grid-cols-2 lg:grid-cols-3 gap-4 py-4 ">
        {giftsList.map((gift) => {
          return <FriendWishComponent key={gift.id} wish={gift} />
        })}
      </div>
    </div>
  )
}

export default FriendModal
